import { render, staticRenderFns } from "./Bslab.vue?vue&type=template&id=566b446a"
import script from "./Bslab.vue?vue&type=script&lang=js"
export * from "./Bslab.vue?vue&type=script&lang=js"
import style0 from "./Bslab.vue?vue&type=style&index=0&id=566b446a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports